import { TextField } from '@mui/material';
import styled from 'styled-components';

export const TextFieldStyled = styled(TextField)`
    & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
        border-color: ${props => props.error ? '#F1416C !important' : '#E4E6EF !important'};
        border-radius: 0.475rem;
    },
`